import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { GuestCartConsumer } from '#src/containers/Cart'
import CartIcon from '#src/components/Header/StandardHeader/icons/mobile/cart.svg'
import styles from './styles.css'

const LoggedOutCart: React.FC = () => {
  const history = useHistory()

  return (
    <Link
      to={{
        ...history.location,
        hash: '#cart'
      }}
      className={styles.navItem}
    >
      <GuestCartConsumer>
        {({ data }) => (
          <>
            {data && data.order.length > 0 && (
              <div className={styles.badge}>{data.order.length}</div>
            )}
            <CartIcon data-testid="mobile-guest-cart-icon" className={styles.cartIcon} />
          </>
        )}
      </GuestCartConsumer>
    </Link>
  )
}

export default LoggedOutCart
